import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { useDentoData } from '../context/DentoContext';

export const DoctorSection = () => {
    const { doctors } = useDentoData();

    if (!doctors || doctors.length === 0) {
        return null;
    }

    const doctor = doctors[0];

    return (
        <section id="doctor" className="py-16 md:py-24 bg-gray-50">
            <div className="container mx-auto px-4">
                <div className="text-center mb-10 md:mb-16">
                    <h2 className="text-3xl md:text-5xl font-extrabold text-black mb-4 font-heading tracking-tight">
                        Meet Our Doctor
                    </h2>
                    <div className="w-16 h-1.5 bg-black mx-auto rounded-full"></div>
                </div>

                <div className="max-w-6xl mx-auto bg-white rounded-[32px] md:rounded-[40px] shadow-2xl shadow-gray-200/50 overflow-hidden flex flex-col md:flex-row border border-gray-100">
                    {/* Doctor Image */}
                    <div className="md:w-1/2 relative bg-gray-50 flex items-center justify-center p-6 lg:p-16">
                        <div className="w-full aspect-square bg-white rounded-2xl md:rounded-3xl shadow-inner flex items-center justify-center relative overflow-hidden group">
                            <img
                                src={doctor.image}
                                alt={doctor.name}
                                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/5 to-transparent"></div>
                        </div>
                    </div>

                    {/* Doctor Info */}
                    <div className="md:w-1/2 p-8 md:p-16 flex flex-col justify-center font-body">
                        <h3 className="text-3xl md:text-4xl font-extrabold text-black mb-2 font-heading tracking-tight">
                            {doctor.name}
                        </h3>
                        <p className="text-lg md:text-xl font-medium text-black/60 mb-6 font-heading">
                            {doctor.qualification} • {doctor.speciality}
                        </p>

                        <div className="flex items-center gap-2 text-black font-semibold mb-8 bg-gray-50 self-start px-4 py-2 rounded-full border border-gray-100 text-sm tracking-wide">
                            <CheckCircle2 size={16} />
                            <span>{doctor.experience} EXPERIENCE</span>
                        </div>

                        <p className="text-black/60 text-lg leading-relaxed mb-10">
                            Dr. Ajinkya is a renowned dental surgeon with extensive experience in advanced dental procedures. Committed to providing the highest quality dental care with modern techniques and personalized attention.
                        </p>

                        <div className="space-y-4">
                            <h4 className="font-bold text-black uppercase tracking-widest text-xs">
                                Certifications & Qualifications:
                            </h4>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                {(doctor.certifications || [
                                    "BDS - Bachelor of Dental Surgery",
                                    "Cosmetic Dentistry Specialist"
                                ]).map((cert, i) => (
                                    <div key={i} className="flex items-center gap-3 text-black/60">
                                        <CheckCircle2 size={16} className="text-black shrink-0" />
                                        <span className="text-sm font-medium">{cert}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
